<template>
  <section class="comm-page dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>
    <section class="dp-right">
      <CommFilterBar :buttonList="buttonList" :searchList="searchList" @callFunction="callFunction" />
      <div class="comm-panel">
        <div class="tbl-scroll-host">
          <el-table class="comm-table" empty-text="暂无数据" :data="rows" v-loading="loading" size="small" height="100%" style="width: 100%">
            <el-table-column prop="Id" label="流水ID" width="100" show-overflow-tooltip />
            <el-table-column prop="BindingId" label="绑定ID" width="100" show-overflow-tooltip />
            <el-table-column prop="RuleId" label="规则ID" width="100" show-overflow-tooltip />
            <el-table-column prop="StudentId" label="学生ID" width="100" show-overflow-tooltip />
            <el-table-column prop="ActionType" label="操作类型" width="110" show-overflow-tooltip />
            <el-table-column prop="ActionRemark" label="说明" min-width="160" show-overflow-tooltip />
            <el-table-column prop="OperateBy" label="操作人" width="100" show-overflow-tooltip />
            <el-table-column prop="OperateTime" label="操作时间" width="160" show-overflow-tooltip />
          </el-table>
        </div>
        <div class="comm-pager">
          <el-pagination layout="total, prev, pager, next, jumper" :current-page="page" :page-size="pageSize" :total="total" @current-change="handleCurrentChange" />
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import './styles/comm-page.css'
import CommFilterBar from './components/CommFilterBar.vue'
import DepartmentPane from '../../components/DepartmentPane'
import { getCommBindLogListPage, exportCommBindLogs } from '../../api/modules/misc'

const defaultButtons = [{ name: '查询', Func: 'handleQuery' }, { name: '导出', Func: 'handleExport' }]

export default {
  components: { CommFilterBar, DepartmentPane },
  data() {
    return {
      loading: false,
      rows: [],
      page: 1,
      pageSize: 10,
      total: 0,
      departmentId: '',
      filters: {},
      searchList: [
        { label: '规则ID', key: 'ruleId', width: '150px', placeholder: '规则ID' },
        { label: '学生ID', key: 'studentId', width: '150px', placeholder: '学生ID' }
      ],
      buttonList: []
    }
  },
  methods: {
    callFunction(item) {
      this.filters = typeof item.search === 'object' ? item.search : {}
      if (typeof this[item.Func] === 'function') this[item.Func]()
    },
    treeNodeClick(data) {
      this.departmentId = data && data.value ? data.value : ''
      this.page = 1
      this.handleQuery()
    },
    handleCurrentChange(page) {
      this.page = page
      this.handleQuery()
    },
    async handleQuery() {
      this.loading = true
      try {
        const res = await getCommBindLogListPage({
          page: this.page,
          pageSize: this.pageSize,
          ruleId: this.filters.ruleId || '',
          studentId: this.filters.studentId || '',
          departmentId: this.departmentId || ''
        })
        if (res.data.success) {
          const pageData = res.data.response || {}
          this.rows = pageData.data || []
          this.total = pageData.dataCount || 0
        } else {
          this.$message.error(res.data.msg || '查询失败')
        }
      } finally {
        this.loading = false
      }
    },
    async handleExport() {
      const res = await exportCommBindLogs({
        ruleId: this.filters.ruleId || '',
        studentId: this.filters.studentId || '',
        departmentId: this.departmentId || ''
      })
      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `话机绑定流水_${new Date().getTime()}.xlsx`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }
  },
  mounted() {
    this.buttonList = defaultButtons
  }
}
</script>
